import { IApplicationState } from '../types/redux';

export const selectSubmitFormData = (state: IApplicationState) => state.formSubmitData;
